import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
    SpecDetail,
    SpecDetailString,
    SpecDetailStringList,
    SpecType,
    SpecTableContent,
} from '../types';
import LanguageTag from './LanguageTag';

interface SpecGroupRowProps {
    displayName: string;
    specs: SpecDetail[];
    onEdit: (displayName: string, specs: SpecDetail[]) => void;
    actionIcon?: IconDefinition;
}

const SpecGroupRow: React.FC<SpecGroupRowProps> = ({
    displayName,
    specs,
    onEdit,
    actionIcon = faPen,
}) => {
    const renderSpecContent = () => {
        if (specs.length === 1 && specs[0].spec_type === SpecType.SPEC_TABLE) {
            const tableContent = specs[0].content as SpecTableContent;
            return (
                <div className="spec-content table-content">
                    <table className="nested-table">
                        <thead>
                            <tr>
                                {tableContent.headers.map((header, index) => (
                                    <th key={index}>{header}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {tableContent.rows.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {row.map((cell, cellIndex) => (
                                        <td key={cellIndex}>{cell}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }

        return specs.map((spec, specIndex) => {
            let specDetailText: string[] = [];

            if (spec.spec_type === SpecType.SPEC_STRING) {
                specDetailText = [(spec as SpecDetailString).content.text];
            } else if (spec.spec_type === SpecType.SPEC_STRING_LIST) {
                specDetailText = (spec as SpecDetailStringList).content.text;
            } else {
                return null;
            }
            return (
                <div key={specIndex} className="spec-content">
                    {spec.language && (
                        <div className="spec-language">
                            <LanguageTag language={spec.language} />
                        </div>
                    )}
                    <div className="spec-text">
                        {specDetailText.map(
                            (text: string, textIndex: number) => (
                                <p key={textIndex}>{text}</p>
                            ),
                        )}
                    </div>
                </div>
            );
        });
    };

    return (
        <tr>
            <td>{displayName}</td>
            <td>
                <div className="grouped-specs">
                    <button
                        className="edit-button"
                        onClick={() => onEdit(displayName, specs)}
                    >
                        <FontAwesomeIcon icon={actionIcon} />
                    </button>
                    {renderSpecContent()}
                </div>
            </td>
        </tr>
    );
};

export default SpecGroupRow;
